import {Directive, HostListener, Input} from '@angular/core';

@Directive({
  selector: '[appAlphaNumeric]',
})
export class AlphaNumericTypeDirective {

  @Input() appAlphaNumeric: boolean;

  constructor() {
  }

  @HostListener('keypress', ['$event']) onKeyPress(event: any) {
    if (this.appAlphaNumeric) {
      const charCode = event.key;
      const numberRegex = new RegExp(`^[a-zA-Z0-9äÄöÖüÜß]+$`);
      if (!numberRegex.test(charCode)) {
        event.preventDefault();
      }
      return true;
    }
  }
}
